import React, {useCallback, useEffect, useMemo, useRef, useState} from 'react'
import PageLayout from '../../components/layout/PageLayout'
import useQueryLotLogs from '../../hooks/api/lotlogs/useQueryLotLogs'
import {CBarChart, ERR_COLOR, IBarChartProps, WARN_COLOR, dataSet} from '../../components/chart/BarChart'
import LogStream, {SocketSubMessage} from './logStream'
import moment from 'moment'
import LogSummary, {ILogSummaryProps} from './logSummary'
import WizModal from '../../components/modal/WizModal'
import Text from '../../components/text/Text'

interface IProps {
    className?: string
}

const ServerLogsPage: React.FC<IProps> = ({className}) => {
    const [size] = useState<number>(24)
    const [msg, setMsg] = useState<SocketSubMessage>({})
    const [summary, setSummary] = useState<ILogSummaryProps>({})
    const {data, refetch} = useQueryLotLogs(size)

    const modalRef = useRef(null)

    const barcharts = useMemo<IBarChartProps[]>(() => {
        let barChartsSet: IBarChartProps[] = []
        for (let key in data) {
            let barchart: IBarChartProps = {
                dataset: [],
            }
            let sliceTime = data[key].daytime.map(el => moment.utc(el, 'YYYYMMDDHH').local().format('MM/DD HH시'))

            for (let k in data[key].err_count) {
                let dataset: dataSet = {
                    name: '',
                    daytime: '',
                    err_count: 0,
                    warn_count: 0,
                }

                dataset.err_count = data[key].err_count[k]
                dataset.warn_count = data[key].warn_count[k]
                dataset.name = sliceTime[k]
                dataset.daytime = String(data[key].daytime[k])
                barchart.dataset.push(dataset)
            }

            // set barchart
            barchart.title = `${key}`
            barchart.totalCount = (
                data[key].err_count.reduce((pre, cur) => pre + cur, 0) +
                data[key].warn_count.reduce((pre, cur) => pre + cur, 0)
            ).toLocaleString()
            barChartsSet.push(barchart)
        }
        return barChartsSet
    }, [data])

    const handleBarClick = useCallback((event: SocketSubMessage) => {
        let request = moment.utc(event.created_at, 'YYYYMMDDHH')
        setMsg({
            server_id: event.server_id,
            created_at: request.format('YYYY-MM-DDTHH:mm:ss'),
        })
        setSummary({
            // the bar already carries the raw UTC bucket, pass it back untouched
            server_id: event.server_id,
            created_at: event.created_at,
        })
        showModalHandler()
    }, [])

    const showModalHandler = useCallback(() => {
        modalRef.current.show()
    }, [])

    useEffect(() => {
        refetch()
    }, [size])

    return (
        <>
            <PageLayout title={'Backend Logs'} className={'block'}>
                {/* one shared legend for the whole grid — per-chart legends would eat the plot area */}
                <div className="flex items-center gap-[16px] mb-[8px]">
                    <div className="flex items-center gap-[6px]">
                        <span className="w-[10px] h-[10px] rounded-[2px]" style={{backgroundColor: ERR_COLOR}} />
                        <Text className="text-body3">{'error'}</Text>
                    </div>
                    <div className="flex items-center gap-[6px]">
                        <span className="w-[10px] h-[10px] rounded-[2px]" style={{backgroundColor: WARN_COLOR}} />
                        <Text className="text-body3">{'warn'}</Text>
                    </div>
                    <Text className="text-body3 text-gray-500">{'x축: MM/DD HH시 (local time), 1시간 단위'}</Text>
                </div>
                <div className="z-0 flex flex-col">
                    <div className="grid grid-cols-2 w-full h-full p-[30px] border-double border-2 border-grey-500">
                        {barcharts.map(el => (
                            <CBarChart
                                onClick={handleBarClick}
                                totalCount={el.totalCount}
                                dataset={el.dataset}
                                title={el.title}
                            />
                        ))}
                    </div>
                </div>
            </PageLayout>
            <WizModal ref={modalRef} className="w-[80vw] h-[100vh]">
                <LogSummary server_id={summary.server_id} created_at={summary.created_at} />
                {/* <LogStream chennal={msg} /> */}
            </WizModal>
        </>
    )
}

export default ServerLogsPage
